export type Stage = 'early' | 'emergent' | 'developing' | 'consolidating' | 'extending';

export type BookType = 'A' | 'B';

export enum BookLabelName {
  EmergentA = 'Emergent A',
  EmergentB = 'Emergent B',
  EarlyA = 'Early A',
  EarlyB = 'Early B',
  DevelopingA = 'Developing A',
  DevelopingB = 'Developing B',
  ConsolidatingA = 'Consolidating A',
  ConsolidatingB = 'Consolidating B',
  ExtendingA = 'Extending A',
  ExtendingB = 'Extending B',
  default = 'default',
}
